import { RestApi } from '../../common/services';
import { store } from '../../common/store/store';
import { Deadline, DeadlineFormValues } from '../types';

const buildingId = () => store.getState().security.ui.buildingId;

const toPayload = (values: DeadlineFormValues) => ({
  title: values.title,
  note: values.note ? values.note : null,
  dueDate: values.dueDate,
  category: values.category,
  priority: values.priority,
});

export const getDeadlines = async (): Promise<Deadline[]> =>
  RestApi.get<never, Deadline[]>(`/building/${buildingId()}/deadline`);

export const createDeadline = async (values: DeadlineFormValues): Promise<Deadline> =>
  RestApi.post<ReturnType<typeof toPayload>, Deadline>(`/building/${buildingId()}/deadline`, toPayload(values));

export const updateDeadline = async (id: string, values: DeadlineFormValues): Promise<Deadline> =>
  RestApi.patch<ReturnType<typeof toPayload>, Deadline>(`/building/${buildingId()}/deadline/${id}`, toPayload(values));

export const completeDeadline = async (id: string, completed: boolean): Promise<Deadline> =>
  RestApi.post<{ completed: boolean }, Deadline>(`/building/${buildingId()}/deadline/${id}/complete`, { completed });

/** Splnění systémového termínu – vrací celý aktualizovaný seznam (u opakujících se přibude další výskyt). */
export const completeSystemDeadline = async (
  deadlineKey: string,
  occurrenceDate: string,
  completed: boolean
): Promise<Deadline[]> =>
  RestApi.post<{ deadlineKey: string; occurrenceDate: string; completed: boolean }, Deadline[]>(
    `/building/${buildingId()}/deadline/system/complete`,
    { deadlineKey, occurrenceDate, completed }
  );

export const deleteDeadline = async (id: string): Promise<void> =>
  RestApi.delete<void>(`/building/${buildingId()}/deadline/${id}`);

export const getNotificationSetting = async (): Promise<{ enabled: boolean }> =>
  RestApi.get<never, { enabled: boolean }>(`/building/${buildingId()}/deadline/notification-setting`);

export const setNotificationSetting = async (enabled: boolean): Promise<{ enabled: boolean }> =>
  RestApi.post<{ enabled: boolean }, { enabled: boolean }>(
    `/building/${buildingId()}/deadline/notification-setting`,
    { enabled }
  );
